import React from 'react'
import { connect } from 'react-redux'

class ChatSectionButtons extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return(
            <>                  
                {/* Insert Rating Request Button */}
                { (this.props.feedback.business.rating_request === 1 && (null === this.props.feedback.rating_page_id && this.props.feedback.access_method !== 'AutoPilot SMS')) &&
                    <div className="row align-items-center ml-0 btn-spacer">
                        <button className="btn btn-primary btn-primary-alt btn-chat"
                            data-text={this.props.feedback.review_text}
                            onClick={this.props.handlePreCanned} type="button"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-title={__("Insert a pre-filled rating request")}
                        >
                            <svg className='ml-1 mr-1' width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.604 1.22a.417.417 0 0 1 .792 0l.633 1.947a.417.417 0 0 0 .396.288h2.048c.403 0 .571.516.245.754L7.06 5.412a.417.417 0 0 0-.151.466l.632 1.947a.416.416 0 0 1-.64.466L5.244 7.088a.417.417 0 0 0-.49 0L3.098 8.29a.416.416 0 0 1-.64-.466l.632-1.947a.417.417 0 0 0-.151-.466L1.282 4.21a.417.417 0 0 1 .245-.754h2.047a.417.417 0 0 0 .397-.288l.633-1.947Z" stroke="#3775B7" strokeWidth=".833" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            {__('Insert Rating Request')}
                        </button>
                    </div>
                }
                
                {/* Canned Responses Button — RTF-4904: hidden entirely when the business has
                    no canned responses configured. Dynamic: `precanned` comes from the feedback
                    payload on chat load, so adding the first one makes the button reappear. */}
                {this.props.feedback.business.precanned && this.props.feedback.business.precanned.length >= 1 &&
                    <div className="d-flex align-items-center ml-0 btn-spacer">
                        <button
                            className="btn btn-primary btn-primary-alt dropdown-toggle no-arrow btn-chat"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            title={__("Send a pre-filled response for common Feedbacks")}
                        >
                            <svg className='ml-1 mr-1' width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.083 3.333h5.834m-5.834 0a.833.833 0 0 1 0-1.666h5.834a.833.833 0 0 1 0 1.666m-5.834 0V7.5a.833.833 0 0 0 .834.833h4.166a.833.833 0 0 0 .834-.833V3.333M4.167 5h1.666" stroke="#3775B7" strokeWidth=".833" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            { __('Canned Responses') }
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {this.props.feedback.business.precanned.map((value,index) => {
                                return <a className="dropdown-item text-capitalize" key={index} onClick={this.props.handlePreCanned} data-text={value.text} href="#">{value.label}</a>
                            })}
                        </div>
                    </div>
                }
                
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        loading: state.loading,
        feedback_id: state.selected_feedback,
        alert: state.alert,
        current_user: state.current_user,
        chatAnyway: state.chatAnyway
    }
}

export default connect(mapStateToProps)(ChatSectionButtons);
